import React, { useState } from 'react';
import { Spin, Alert, message } from 'antd';
import { usePW9411Query } from './hooks/usePW9411Query';
import QueryForm from './components/QueryForm';
import EmployeeCard from './components/EmployeeCard';
import AttendanceTable from './components/AttendanceTable';
import type { QueryRequest } from '../../services/pw9411Api';
import './PW9411Form.css';

/**
 * PW9411Form — 個人出勤狀況查詢 (pw9411f1)
 *
 * 對應 FoxPro 的 CMDQRY.Click → DO FORM PW9210F6 WITH "", SYS_USER_ID
 * Web 版本：輸入員工代號 + 日期範圍 → 顯示出勤記錄列表
 */
const PW9411Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = usePW9411Query();

  const [empCode, setEmpCode] = useState('');
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');

  const handleDateRangeChange = (start: string, end: string) => {
    setDateStart(start);
    setDateEnd(end);
  };

  const handleQuery = () => {
    const trimmedEmp = empCode.trim();
    if (!trimmedEmp) {
      message.warning('請輸入員工代號');
      return;
    }
    if (!dateStart || !dateEnd) {
      message.warning('請選擇查詢日期範圍');
      return;
    }
    if (dateEnd < dateStart) {
      message.warning('截止日不可早於起始日');
      return;
    }

    const req: QueryRequest = {
      emp_code: trimmedEmp,
      date_start: dateStart,
      date_end: dateEnd,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9411-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          個人出勤狀況查詢 (9411)
        </h2>

        <QueryForm
          empCode={empCode}
          dateStart={dateStart}
          dateEnd={dateEnd}
          loading={loading}
          onEmpCodeChange={setEmpCode}
          onDateRangeChange={handleDateRangeChange}
          onQuery={handleQuery}
        />

        {queried && result?.employee && (
          <EmployeeCard employee={result.employee} />
        )}

        {queried && !noData && result && result.records.length > 0 && (
          <AttendanceTable
            records={result.records}
            total={result.total}
          />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的出勤記錄，請確認員工代號及日期範圍是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9411Form;
